import A from './types';

const initialState = {
  creditCardInfo: {
    data: {
      cards: [],
    },
    error: false,
    loading: false,
    isFirstLoading: true,
  },
  addCardInfo: {},
  deleteCardInfo: {},
  setDefaultCardInfo: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.CREDIT_CARD_INFO: {
      if (action.pending) {
        return {
          ...state,
          creditCardInfo: {
            data: state.creditCardInfo.data,
            loading: true,
            error: false,
            isFirstLoading: state.creditCardInfo.isFirstLoading,
          },
        };
      }
      if (action.error) {
        return {
          ...state,
          creditCardInfo: {
            data: state.creditCardInfo.data,
            loading: false,
            error: action.payload.message,
            isFirstLoading: false,
          },
        };
      }
      if (action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          creditCardInfo: {
            data: action.payload.data,
            loading: false,
            error: false,
            isFirstLoading: false,
          },
        };
      }
      return {
        ...state,
        creditCardInfo: {
          data: state.creditCardInfo.data,
          loading: false,
          error: action.payload.state_message,
          isFirstLoading: false,
        },
      };
    }
    case A.SET_DEFAULT_CARD: {
      if (action.pending) {
        return {
          ...state,
          setDefaultCardInfo: {
            loading: true,
            disable: true,
            error: false,
          },
        };
      }
      if (action.error) {
        return {
          ...state,
          setDefaultCardInfo: {
            loading: false,
            disable: false,
            error: action.payload.message,
          },
        };
      }
      if (action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          setDefaultCardInfo: {
            loading: false,
            disable: false,
            error: false,
          },
          creditCardInfo: {
            ...state.creditCardInfo,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        setDefaultCardInfo: {
          loading: false,
          disable: false,
          error: action.payload.state_message,
        },
      };
    }
    case A.DELETE_CARD: {
      if (action.pending) {
        return {
          ...state,
          deleteCardInfo: {
            loading: true,
            disable: true,
            error: false,
          },
        };
      }
      if (action.error) {
        return {
          ...state,
          deleteCardInfo: {
            loading: false,
            disable: false,
            error: true,
          },
        };
      }
      if (action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          deleteCardInfo: {
            loading: false,
            disable: false,
            error: false,
          },
          creditCardInfo: {
            ...state.creditCardInfo,
            data: {
              cards: action.payload.data.customer.sources,
            },
          },
        };
      }
      return {
        ...state,
        deleteCardInfo: {
          loading: false,
          disable: false,
          error: true,
        },
      };
    }
    case A.ADD_CARD: {
      if (action.pending) {
        return {
          ...state,
          addCardInfo: {
            loading: true,
            disable: true,
            error: false,
          },
        };
      }
      // 兼容
      if (action.error) {
        return {
          ...state,
          addCardInfo: {
            loading: false,
            disable: false,
            error: action.payload.message,
          },
        };
      }
      if (action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          addCardInfo: {
            loading: false,
            disable: false,
            error: action.payload.message,
          },
        };
      }
      return {
        ...state,
        addCardInfo: {
          loading: false,
          disable: false,
          error: action.payload.state_message,
        },
      };
    }
    case A.PAYMENT_SETTING_PAGE_ASYNG_ERROR_HIDE: {
      return {
        ...state,
        [action.payload.type]: {
          ...[action.payload.type],
          error: false,
          childError: false,
        },
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/paymentSettingPage/reducer.js